import React, { Component } from 'react';
import '../style/plano.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import { transactionID } from "../services/helpers";


class Plano extends Component {

    constructor(props) {
        super(props);
        let localStorageClientInfo = localStorage.getItem("clientInfo");

        this.state = {
            infoDetails: [],
            SMS: [],
            DATA: [],
            VOICE: [],
            colorBar: ["bar-light-blue","bar-dark-blue","bar-yellow",],
            bundleName: "",
            bundleExpiry: "",
            MSISDN: (localStorageClientInfo !== null) ? JSON.parse(localStorage.getItem("clientInfo")).number : "",
            accessToken: (localStorageClientInfo !== null) ? JSON.parse(localStorage.getItem("clientInfo")).accessToken : "",
            errorLoad: false,
            ready: false
        }
    };
    
    homeHistory = () => {

        axios.post(`https://www.pagtel.com.br/Hub360Correios/v2/homeHistory`, {
            transactionID: transactionID('AAO'),
            MSISDN: this.state.MSISDN
        }, { headers: {"Authorization": "Bearer " + this.state.accessToken} })
        .then(res => {
            if(res.data.code === "P00"){
                
                if(res.data.infoDetails !== null) {
                    this.setState({infoDetails: res.data.infoDetails, ready: true});
                    localStorage.setItem('homeHistory', JSON.stringify(res.data));
                }
                
                
            }
            else {
                this.setState({errorLoad: true});
            }
        })
        .catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao conectar com o servidor",
                type: 'error'
            });
        })
    }

    BundleInfo = () => {

        axios.post(`https://www.pagtel.com.br/Hub360Correios/v2/BundleInfo`, {
            transactionID: transactionID('AAP'),
            MSISDN: this.state.MSISDN
        }, { headers: {"Authorization": "Bearer " + this.state.accessToken} })
        .then(res => {
            if(res.data.code === "P00"){
                let validity = res.data.bundleExpiry;
                this.setState({
                    bundleName: res.data.bundleName,
                    bundleExpiry:  ((validity!== "")&&(validity!== null)&&(validity!== undefined)) ? validity: "00-00-0000"                });
                localStorage.setItem('BundleInfo', JSON.stringify(res.data));
                
            }
            else {
                this.setState({errorLoad: true});
            }
        })
        .catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao conectar com o servidor",
                type: 'error'
            });
        })
    }

    formartPercent = (total, used) => {

        return ((100*parseFloat(used.replace(",",".")))/parseFloat(total.replace(",","."))).toFixed(0) + "%";
    }

    formartDate = (date) => {
        return date.split("-")[0]+"/"+date.split("-")[1]+"/"+date.split("-")[2];
    }

    componentDidMount = () => {
        this.homeHistory();
        this.BundleInfo();
        this.setState({errorLoad: false});
    }
    
  

  render() {

    
    return (
        <div className={`plan ${this.state.ready ? "":"d-none"}`}>
            {(this.state.infoDetails !== []) && 
                <ul className="plan--list">
                <li className="plan--list-header">
                    <div className="plan--list-header-yellow">{this.state.bundleName}</div>
                    <div className="plan--list-header-blue">Validade: {this.formartDate(this.state.bundleExpiry)}</div>
                </li>   
                {this.state.infoDetails.map((item,i) =>
                    <li key={i} className="plan--list-info">
                        <div className="plan--list-info-bar">
                            {(item.type === "DATA") && <h5>Internet</h5>}
                            {(item.type === "VOICE") && <h5>Ligação</h5>}
                            {(item.type === "SMS") && <h5>SMS</h5>}
                            <p>Consumo {this.formartPercent(item.details.total, item.details.used)}</p>
                            <div className="plan--bar">
                                <div style={{width: this.formartPercent(item.details.total, item.details.used)}} className={`plan--bar-inside ${this.state.colorBar[i]}`}></div>
                            </div>
                        </div>
                        {(item.type === "DATA") && 
                            <div className="plan--list-info-bar-count">
                                <strong>{item.details.used} {item.details.unity}</strong>
                                <p>de {item.details.total} {item.details.unity}</p>
                            </div>
                        }
                        {(item.type === "VOICE") && 
                            <div className="plan--list-info-bar-count">
                                <strong>{item.details.used} MIN</strong>
                                <p>de {item.details.total} MIN</p>
                            </div>
                        }
                        {(item.type === "SMS") && 
                            <div className="plan--list-info-bar-count">
                                <strong>{item.details.used} SMS</strong>
                                <p>de {item.details.total} SMS</p>
                            </div>
                        }
                        
                    </li>
                )}
                </ul>
            }
            {this.state.errorLoad && 
                <div className="error-reload">
                    <h3>Oooops, algo deu errado :(</h3>
                    <p>Ocorreu um erro ao exibir os dados<br/>
                    Toque no botão abaixo para tentar<br/>
                    novamente</p>
                    <div className="error-roload-btn" onClick={this.componentDidMount}>Tentar Novamente</div>
                </div>
            }
        </div>
    )
  }

  
}

export default Plano; // Don’t forget to use export default!